if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        this.addOnProducts = [];

        this.isBundle = this.dataset.bundleGifts === 'true';

        this.isFavouritesCard = this.dataset.type === 'FavouritesCard';

        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.isFavouritesCard) {
          this.variantSelector = this.querySelector('[data-variant-select]');
          this.variantSelector.addEventListener(
            'change',
            this.onFavouritesCardVariantChange.bind(this)
          );
        }
      }

      submitForm() {
        this.form.submit();
      }

      connectedCallback() {
        if (this.dataset.mainProduct === 'true') {
          subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.addOnProducts = [];
          });
        }
      }

      onFavouritesCardVariantChange(evt) {
        const productHandle = this.dataset.productHandle;
        const variantId = evt.target.value;

        fetch(
          `/products/${productHandle}?variant=${variantId}&section_id=card_swym`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            const card = html.querySelector('.card');
            const button = card.querySelector('product-form .button');

            this.querySelector('.button').replaceWith(button);
          });
      }

      onSubmitHandler(evt) {
        if(evt) {
          evt.preventDefault();
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender?.().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          formData.append('sections_url', window.location.pathname);
        }

        let variantId = formData.get('id');

        if (this.isBundle) {
          let product_data = JSON.parse(this.dataset.bundle);

          product_data.forEach((item, index) => {
            if (item.id == variantId) {
              formData.append(
                `properties[_bundleSize]`,
                item.properties._bundleSize
              );
              formData.append(
                `properties[_bundleGift]`,
                item.properties._bundleGift
              );
              formData.append(`properties[_gui]`, item.properties._gui);
            } else {
              formData.append(`items[${index}][id]`, item.id);
              formData.append(`items[${index}][quantity]`, item.quantity);
              formData.append(
                `items[${index}]properties[_gui]`,
                item.properties._gui
              );
              formData.append(
                `items[${index}]properties[_bundleSize]`,
                item.properties._bundleSize
              );
              if (item.properties._bundleGift) {
                formData.append(
                  `items[${index}]properties[_bundleGift]`,
                  item.properties._bundleGift
                );
              }
            }
          });
        }

        this.addOnProducts = [...new Set(this.addOnProducts)];
        if (this.addOnProducts.length > 0) {
          this.addOnProducts.forEach((id, index) => {
            formData.append(`items[${index}][id]`, id);
            formData.append(`items[${index}][quantity]`, 1);
          });
        }

        const addToCartRequest = () =>
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (aa) {
                const productData =
                  JSON.parse(localStorage.getItem('algoliaProducts')) || [];
                const product = productData.find(
                  (p) => p.productId === this.productId
                );
              }

              if (this.sectionId == 'Quickview') {
                document.querySelector('#Quickview').remove();
              }

              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;

              if (this.cart) {
                this.cart.renderContents(response);
              } else {
                const cartBubble = document.querySelector('#cart-icon-bubble');
                if (window.cartStrings.pulsate) {
                  cartBubble?.classList.add('pulsate');

                  setTimeout(() => {
                    cartBubble?.classList.remove('pulsate');
                  }, 3000);
                }

                if (response.sections['cart-icon-bubble'] && cartBubble) {
                  const html = new DOMParser().parseFromString(
                    response.sections['cart-icon-bubble'],
                    'text/html'
                  );
                  cartBubble.querySelector(
                    '.cart-count-bubble__count'
                  ).innerHTML = html.querySelector(
                    '.cart-count-bubble__count'
                  ).innerHTML;
                }
              }
            });

        config.body = formData;
        const isLimitQuantity = this.dataset.limitQuantity === 'true';

        if (isLimitQuantity) {
          formData.set('quantity', 1);
          config.body = formData;

          fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((cart) => {
              const selectedVariantId = String(formData.get('id'));
              const selectedProductId = Number(this.dataset.productId);
              const isLimitedProductAlreadyInCart = cart.items.some((item) => {
                if (Number.isFinite(selectedProductId) && selectedProductId > 0) {
                  return Number(item.product_id) === selectedProductId;
                }

                return String(item.variant_id) === selectedVariantId;
              });

              if (isLimitedProductAlreadyInCart) {
                if (this.cart) {
                  if (this.sectionId == 'Quickview') {
                    document.querySelector('#Quickview')?.remove();
                  }
                  return this.cart.fullUpdate(true);
                }

                window.location.href = routes.cart_url;
                return null;
              }

              return addToCartRequest();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty'))
                this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');

              if(this.querySelector('.loading__spinner')) {
                this.querySelector('.loading__spinner').classList.add('hidden');
              }
            });
          return;
        }

        addToCartRequest()
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            if(this.querySelector('.loading__spinner')) {
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      addAddOnProducts(id) {
        this.addOnProducts.push(id);
      }

      removeAddOnProducts(id) {
        this.addOnProducts = this.addOnProducts.filter((id) => id !== id);
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('bundle-select')) {
  customElements.define(
    'bundle-select',
    class BundleSelect extends HTMLElement {
      constructor() {
        super();

        this.sku = this.querySelector('.bundle__sku');
        this.name = this.querySelector('.bundle__name');

        this.dropdown = this.querySelector('.product__bundle-product-select');

        if (this.dropdown) {
          this.dropdown.addEventListener(
            'change',
            this.onChangeHandler.bind(this)
          );
        }
      }

      onChangeHandler(evt) {
        this.sku.value = evt.target.value;
        this.name.value = evt.target.selectedOptions[0].dataset.name;
      }
    }
  );
}
